/**
 * 기간 연장 시 이어 붙일 구독 만료일.
 * Firestore `users.license`를 우선하고, 없으면 licenses[] 중 동일 planType·활성 표시 항목의 expiresAt 최대값.
 * (배열 순서로 find하면 잘못된 과거 활성 건을 잡는 버그 방지)
 */
export function parseFirestoreLikeDate(v: unknown): Date | null {
  if (v == null) return null;
  if (typeof v === 'object' && v !== null && 'toDate' in v && typeof (v as { toDate: () => Date }).toDate === 'function') {
    try {
      const d = (v as { toDate: () => Date }).toDate();
      return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
    } catch {
      return null;
    }
  }
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  if (typeof v === 'number' || typeof v === 'string') {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export function getExtensionChainEndDate(
  userData: { license?: any; licenses?: any[] } | null | undefined,
  planType: string,
  excludePaymentId: string
): Date | null {
  const exPid = String(excludePaymentId || '').trim();
  const primary = userData?.license;
  const primaryPid = primary?.paymentId != null ? String(primary.paymentId).trim() : '';
  if (primary && primaryPid !== exPid && primary.planType === planType && primary.isRefunded !== true) {
    const ex = parseFirestoreLikeDate(primary.expiresAt);
    if (ex) return ex;
  }
  const arr: any[] = userData && Array.isArray(userData.licenses) ? userData.licenses : [];
  let best: Date | null = null;
  for (const l of arr) {
    const pid = l?.paymentId != null ? String(l.paymentId).trim() : '';
    if (pid === exPid) continue;
    if (l?.planType !== planType) continue;
    if (l?.isRefunded === true) continue;
    if (!(l?.isActive === true || l?.isActivated === true)) continue;
    const e = parseFirestoreLikeDate(l?.expiresAt);
    if (!e) continue;
    if (!best || e.getTime() > best.getTime()) best = e;
  }
  return best;
}
